// src/pages/api/ekdAPI.ts — holistic Enterprise-Knowledge SME review API.
import { apiGet, apiPost } from "../API";
const BASE = "/adriva_api/ekd";

export type LaneKey = "structure" | "reference" | "rules" | "context";

export interface ReviewItem {
  id: string; type: string; title: string; subtitle?: string; detail?: string;
  question?: string; kind?: string;
  status: "pending" | "confirmed" | "flagged"; note?: string; value?: any;
  editable?: boolean; lockable?: boolean; empty?: boolean; value_count?: number;
  seed_confirmed?: boolean; field?: string;
  why?: string; confirm_label?: string; flag_label?: string; readonly?: boolean;
  badge?: string; gap_type?: string;
}
export interface LaneCounts { total: number; confirmed: number; flagged: number; pending: number; }
export interface LaneResponse {
  success: boolean; entity_id: string; lane: LaneKey;
  groups: Record<string, ReviewItem[]>; readonly_groups: string[]; counts: LaneCounts;
}
export interface EkdSummary {
  success: boolean; entity_id: string; entity?: string; domain?: string;
  lanes: Record<LaneKey, LaneCounts>;
  totals: { decisions: number; confirmed: number };
  governed_reference_domains: number;
  pending_reference_domains?: number;
  readiness: { baseline_business_readiness?: number; sme_decided_share: number; note?: string; };
}

export function ekd_getSummary(entityId: string): Promise<EkdSummary> {
  return apiGet(`${BASE}/${encodeURIComponent(entityId)}/summary`);
}
export function ekd_getLane(entityId: string, lane: LaneKey): Promise<LaneResponse> {
  return apiGet(`${BASE}/${encodeURIComponent(entityId)}/lane/${lane}`);
}
export function ekd_refreshReference(entityId: string): Promise<{ success: boolean; reference_domains: number; values: number; note?: string }> {
  return apiPost(`${BASE}/${encodeURIComponent(entityId)}/refresh-reference-domains`, {});
}
export function ekd_review(entityId: string, item_type: string, item_id: string,
                          status: string, value: any = null, note = ""): Promise<LaneResponse> {
  return apiPost(`${BASE}/${encodeURIComponent(entityId)}/review`, { item_type, item_id, status, value, note });
}
